export const starEmpty = require('./star-empty.svg').default
export const starFull = require('./star-full.svg').default
export const starHalf = require('./star-half.svg').default